// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DigitalInstrumentalCluster_colLg17__j-OyH {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% / 7);
  max-width: calc(100% / 7);
}

.DigitalInstrumentalCluster_pl0Important__am3yf {
  padding-left: 0 !important;
}

.DigitalInstrumentalCluster_kipBoxes__gWoQ5
{
  border: 1.5px solid #32879c;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
  margin-left: 1px;
}

.DigitalInstrumentalCluster_kpiHeight__2F0uP{
  height: 65px;
  min-height: 65px;
  justify-content: center;
}

.DigitalInstrumentalCluster_fw_600__-dpFy {
  font-weight: 600 !important;
}

.DigitalInstrumentalCluster_KPI_left_right_card__bJ-sg{
  background: #32879c;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.DigitalInstrumentalCluster_KPI_right_left_Card__LQ889{
  background: #32879c;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}

.DigitalInstrumentalCluster_forBetweenBorder__tUEb-{
  border-right: black 1px solid;
  margin: 4px 0px 4px 0px;
}

.DigitalInstrumentalCluster_textColorGreen__Mw38a{
  color: #32879c;
}

.DigitalInstrumentalCluster_tableTitles__pDfg\\+{
  border-radius: 5px;
  padding: 6px 0px;
  display: flex;
  justify-content: space-between;
  font-size: 0.90rem !important;
  font-weight: 600 !important;
}

.DigitalInstrumentalCluster_fullTable__1bAJX{
    border-radius: 6px;
    background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
}

.DigitalInstrumentalCluster_topBottomPerformingTables__3N1He {
  height: 400px; /* Set the height of the table container */
  overflow-y: scroll; /* Add vertical scroll when content overflows */
  margin-bottom: 0;
  scrollbar-width: thin; 
}


.DigitalInstrumentalCluster_switchInput__SdV-v {
  width: 50px !important;
  height: 20px;
  cursor: pointer;
  appearance: none;
  /* remove default switch */
  -webkit-appearance: none;
  position: relative;
  border-radius: 20px;
  background-color: #6c757d;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  outline: none;
  border: none;
}

/* Text when OFF */
.DigitalInstrumentalCluster_switchInput__SdV-v::before {
  content: "Top 20";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  font-size: 8px;
  border-radius: 20px;
  margin-left: 0.5rem;
}

/* Knob (ball) */
.DigitalInstrumentalCluster_switchInput__SdV-v::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: #ffffff;
  /* OFF state ball color */
  border-radius: 50%;
  /* transition: transform 0.3s ease, background 0.3s ease; */
}

/* ON State */
.DigitalInstrumentalCluster_switchInput__SdV-v:checked {
  background-color: #358696;
}

.DigitalInstrumentalCluster_switchInput__SdV-v:checked::before {
  content: "All";
  margin-left: 0rem;
}

.DigitalInstrumentalCluster_switchInput__SdV-v:checked::after {
  transform: translateX(30px);
  background: #fff;
  /* ON state ball color */
}

/* Focus state → Light Green border */
.DigitalInstrumentalCluster_switchInput__SdV-v:focus {
  box-shadow: 0 0 0 3px #c8e1e6;
  /* lightgreen glow */
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/DigitalInstrumentCluster/DigitalInstrumentalCluster.module.css"],"names":[],"mappings":"AAAA;EACE,YAAwB;EAAxB,cAAwB;EAAxB,0BAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;EACE,aAAa,EAAE,0CAA0C;EACzD,kBAAkB,EAAE,+CAA+C;EACnE,gBAAgB;EAChB,qBAAqB;AACvB;;;AAGA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,4DAA4D;EAC5D,aAAa;EACb,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA,aAAa;AACb;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,6BAA6B;EAC7B,oBAAoB;AACtB","sourcesContent":[".colLg17 {\n  flex: 0 0 calc(100% / 7);\n  max-width: calc(100% / 7);\n}\n\n.pl0Important {\n  padding-left: 0 !important;\n}\n\n.kipBoxes\n{\n  border: 1.5px solid #32879c;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n  margin-left: 1px;\n}\n\n.kpiHeight{\n  height: 65px;\n  min-height: 65px;\n  justify-content: center;\n}\n\n.fw_600 {\n  font-weight: 600 !important;\n}\n\n.KPI_left_right_card{\n  background: #32879c;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.KPI_right_left_Card{\n  background: #32879c;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.forBetweenBorder{\n  border-right: black 1px solid;\n  margin: 4px 0px 4px 0px;\n}\n\n.textColorGreen{\n  color: #32879c;\n}\n\n.tableTitles{\n  border-radius: 5px;\n  padding: 6px 0px;\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.90rem !important;\n  font-weight: 600 !important;\n}\n\n.fullTable{\n    border-radius: 6px;\n    background: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 10px;\n}\n\n.topBottomPerformingTables {\n  height: 400px; /* Set the height of the table container */\n  overflow-y: scroll; /* Add vertical scroll when content overflows */\n  margin-bottom: 0;\n  scrollbar-width: thin; \n}\n\n\n.switchInput {\n  width: 50px !important;\n  height: 20px;\n  cursor: pointer;\n  appearance: none;\n  /* remove default switch */\n  -webkit-appearance: none;\n  position: relative;\n  border-radius: 20px;\n  background-color: #6c757d;\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\n  outline: none;\n  border: none;\n}\n\n/* Text when OFF */\n.switchInput::before {\n  content: \"Top 20\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 600;\n  font-size: 8px;\n  border-radius: 20px;\n  margin-left: 0.5rem;\n}\n\n/* Knob (ball) */\n.switchInput::after {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  background: #ffffff;\n  /* OFF state ball color */\n  border-radius: 50%;\n  /* transition: transform 0.3s ease, background 0.3s ease; */\n}\n\n/* ON State */\n.switchInput:checked {\n  background-color: #358696;\n}\n\n.switchInput:checked::before {\n  content: \"All\";\n  margin-left: 0rem;\n}\n\n.switchInput:checked::after {\n  transform: translateX(30px);\n  background: #fff;\n  /* ON state ball color */\n}\n\n/* Focus state → Light Green border */\n.switchInput:focus {\n  box-shadow: 0 0 0 3px #c8e1e6;\n  /* lightgreen glow */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colLg17": `DigitalInstrumentalCluster_colLg17__j-OyH`,
	"pl0Important": `DigitalInstrumentalCluster_pl0Important__am3yf`,
	"kipBoxes": `DigitalInstrumentalCluster_kipBoxes__gWoQ5`,
	"kpiHeight": `DigitalInstrumentalCluster_kpiHeight__2F0uP`,
	"fw_600": `DigitalInstrumentalCluster_fw_600__-dpFy`,
	"KPI_left_right_card": `DigitalInstrumentalCluster_KPI_left_right_card__bJ-sg`,
	"KPI_right_left_Card": `DigitalInstrumentalCluster_KPI_right_left_Card__LQ889`,
	"forBetweenBorder": `DigitalInstrumentalCluster_forBetweenBorder__tUEb-`,
	"textColorGreen": `DigitalInstrumentalCluster_textColorGreen__Mw38a`,
	"tableTitles": `DigitalInstrumentalCluster_tableTitles__pDfg+`,
	"fullTable": `DigitalInstrumentalCluster_fullTable__1bAJX`,
	"topBottomPerformingTables": `DigitalInstrumentalCluster_topBottomPerformingTables__3N1He`,
	"switchInput": `DigitalInstrumentalCluster_switchInput__SdV-v`
};
export default ___CSS_LOADER_EXPORT___;
